import React, { FC } from 'react';
import { ErrorMessage, Field } from 'formik';
import { useTranslation } from 'react-i18next';
import { IFormControl, IFormOption } from '../formInterface';
import { Select, Typography, Option } from '@getgo/chameleon-web/react';
import FormErrorMessageBox from './formErrorMessageBox';

const FormSelect: FC<IFormControl> = (props) => {
  const { t } = useTranslation();
  const { title, name, required, options, ...rest } = props;
  return (
    <Field name={name} {...rest}>
      {({ form, field, meta: { touched, error } }: any) => {
        return (
          <>
            <Typography variant="caption-default-02" color="text-01" className="select-field-label">
              {title}
              {required && '*'}
            </Typography>
            <Select
              id={name}
              {...rest}
              {...field}
              value={' '}
              className="full-width"
              error={touched && error}
            >
              <Option key={' '} value={' '} selected>
                {t('event.form.chooseOnePlaceholder')}
              </Option>
              {options &&
                options.map((option: IFormOption) => {
                  return (
                    <Option key={option.optionKey} value={option.optionKey}>
                      {option.title}
                    </Option>
                  );
                })}
            </Select>
            <ErrorMessage
              name={name}
              render={() => <FormErrorMessageBox errorMessage={form.errors[name]} />}
            />
          </>
        );
      }}
    </Field>
  );
};

export default FormSelect;
